import React, { FC } from "react";

import { FormikProps } from "formik";

import { Form as FormControl } from "react-bootstrap";
import FloatingLabel from "react-bootstrap/FloatingLabel";

import InputGroup from "react-bootstrap/InputGroup";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { useTranslation } from "react-i18next";
import { DecisionTypesCode } from "components/Reports/reportAssets/assets";
import { FormControlsValues } from "./SummaryStepTypes";

type FormSummarySectionProps = {
  formikProps: FormikProps<FormControlsValues>;
};

const FormSummarySection: FC<FormSummarySectionProps> = ({ formikProps }) => {
  const { t } = useTranslation();
  const { values, handleChange } = formikProps;

  return (
    <div>
      <Row className="mb-3">
        <InputGroup hasValidation>
          <FormControl.Group as={Col} md="4" className="m-3">
            <FloatingLabel
              controlId="floatingInput"
              className="text-right"
              label={t("offenceTypeName")}
            >
              <FormControl.Control
                type="text"
                readOnly
                size="lg"
                name="offenceTypeName"
                value={values.offenceTypeName}
                onChange={handleChange}
                placeholder={t("offenceTypeName")}
                className="square border border-secondary form-control report-input"
              />
            </FloatingLabel>
          </FormControl.Group>

          <FormControl.Group as={Col} md="4" className="m-3">
            <FloatingLabel
              controlId="floatingInput"
              label={t("decisionTypeName")}
            >
              <FormControl.Control
                aria-describedby="label of descicion"
                readOnly
                size="lg"
                name="decisionTypeName"
                value={values.decisionTypeName}
                onChange={handleChange}
                className="square border border-secondary form-control report-input"
              />
            </FloatingLabel>
          </FormControl.Group>

          {values.decisionTypeID ===
            DecisionTypesCode.DisqualificationReport && (
            <FormControl.Group as={Col} md="4" className="m-3">
              <FloatingLabel
                controlId="floatingInput"
                className="text-right"
                label={t("rejectionReasons")}
              >
                <FormControl.Control
                  aria-describedby="type of desicion"
                  readOnly
                  size="lg"
                  name="rejectionReasons"
                  value={values.rejectionReasons}
                  onChange={handleChange}
                  className="square border border-secondary form-control report-input"
                />
              </FloatingLabel>
            </FormControl.Group>
          )}
        </InputGroup>
      </Row>
    </div>
  );
};

export default FormSummarySection;
